import dayjs, { Dayjs } from "dayjs";
/**
 * 热门/最新的枚举
 */
export enum HotNewEnum {
  Hot = 0,
  New = 1,
}

export enum PlatformEnum {
  Twitter = 0,
  Articles = 1,
  Newsletter = 2,
  Announcement = 3,
}

/** 地址缩写 */
export const onAddressAbbreviation = (address: string) => {
  if (!address) return;
  return (
    address.substring(0, 5) + "..." + address.substring(address.length - 4)
  );
};

export const day = (d: string | Dayjs | Date) => {
  //@ts-ignore
  return dayjs.utc(d).local();
};
export const mintTime = () => {
  return day("2024-03-10 12:00");
};


// export const bascScanUrl = 'https://testnet.bscscan.com'
export const bascScanUrl = 'https://scan.merlinchain.io'
// export const contractAddress = "0x5BF630B8d7d72600D116F8CBBE834F6a6De087Ff";

export const contractAddress = "0xdb02b772Ae38b8Ef0d5Dd39D5f0a5849fdcA3E14";
// bascScanUrl